import React from "react";
import { AiFillTwitterSquare, AiFillGithub } from "react-icons/ai";
import { CenterLayout } from "components/layouts";
import cx from "classnames";
import PropTypes from "prop-types";

function PageFooter(props) {
  const { className } = props;

  return (
    <div
      className={cx("bg-gray-900 h-full text-medium font-medium", className)}
    >
      <CenterLayout>
        <div className="flex items-center">
          <h1 className="flex-grow text-2xl font-cursive text-gray-100">
            Dahn Alfred S. Registrado
          </h1>
          <div>
            <a
              className="block mb-1 text-lg text-gray-300 hover:text-gray-100"
              href="https://twitter.com/DahnRegistrado"
            >
              <AiFillTwitterSquare className="mr-3 inline" size="1.8em" />
              Twitter
            </a>
            <a
              className="block mb-1  text-lg text-gray-300 hover:text-gray-100"
              href="https://github.com/Dahnnyboi"
            >
              <AiFillGithub className="mr-3 inline" size="1.8em" />
              Github
            </a>
          </div>
        </div>
      </CenterLayout>
    </div>
  );
}

PageFooter.propTypes = {
  className: PropTypes.string,
};

PageFooter.defaultProps = {
  className: "",
};

export default PageFooter;
